import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "@utils/utils";
import { makeStyles } from "@material-ui/core/styles";
import { createshift } from "../../Redux/actions";
import {
  CircularProgress,
  Button,
  Paper,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import { fetchEmployees } from "../../Redux/actions";

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 500,
    margin: "auto",
    overflow: "hidden",
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing.unit,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 450,
  },
  halfTextField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 205,
  },
  mediumTextField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 225,
  },
  halfSelectField: {
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 205,
  },
  checkbox: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit * 2,
  },
  submitButton: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  switch: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    width: 450,
  },
  selectHalfFormControl: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    width: 215,
  },
  missing_number_of_hours: {
    margin: "18px 0 -12px 18px",
    fontSize: "12px",
    width: 215,
  },
  heading: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
  },
}));

const Time = () => {
  const dispatch = useDispatch();
  const [shift, setShift] = useState(null);
  const shifts = useSelector((state) => state.shift.payload);
  const employees = useSelector((state) => state.employees.payload);
  const [employeeId, setEmployeeId] = useState("All");
  const [employeeName, setEmployeeName] = useState("All");
  const [workingHours, setWorkingHours] = useState(null);
  const [timeStart, setTimeStart] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);
  const [lateAllowed, setLateAllowed] = useState(null);
  const [halfLeaveAfter, setHalfLeaveAfter] = useState(null);
  const [fullLeaveAfter, setFullLeaveAfter] = useState(null);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, []);
  const classes = useStyles();
  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      shift_name: shift,
      employee_id: employeeId,
      employee_shift: employeeName,
      working_hours: workingHours,
      start_time: timeStart,
      end_time: timeEnd,
      start_date: dateStart,
      end_date: dateEnd,
      late_allowed: lateAllowed,
      half_leave_after: halfLeaveAfter,
      full_leave_after: fullLeaveAfter,
    };

    dispatch(createshift(payload));
  };

  const handleInputChange = (e) => {
    if (e.target.value === "All") {
      setEmployeeId("All");
      setEmployeeName("All");
    } else {
      const employee = employees.find((emp) => emp._id === e.target.value);
      setEmployeeId(e.target.value);
      setEmployeeName(`${employee.first_name} ${employee.last_name}`);
    }
  };

  return (
    <>
      {!shifts ? (
        <CircularProgress />
      ) : (
        <Paper className={`${classes.paper} shift-paper`}>
          <form
            className={classes.form}
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <TextField
              id="shift_name"
              name="shift_name"
              label="Shift Name"
              required
              type="text"
              value={shift}
              onChange={(e) => setShift(e.target.value)}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <FormControl className={classes.formControl}>
              <InputLabel id="employees" shrink>
                Employees
              </InputLabel>
              <Select
                fullWidth
                labelId="employees"
                displayEmpty={true}
                value={employeeId}
                onChange={(e) => handleInputChange(e)}
              >
                <MenuItem value="All">All Employees</MenuItem>
                {employees.map(function (employee, i) {
                  return (
                    <MenuItem value={employee._id} key={i}>
                      {employee.first_name} {employee.last_name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <TextField
              id="start_time"
              name="start_time"
              label="Start Time"
              required
              type="time"
              value={timeStart}
              onChange={(e) => setTimeStart(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="end_time"
              name="end_time"
              label="End Time"
              required
              type="time"
              value={timeEnd}
              onChange={(e) => setTimeEnd(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="working_hours"
              name="working_hours"
              label="Working Hours"
              required
              placeholder="Enter hours"
              type="number"
              value={workingHours}
              onChange={(e) => setWorkingHours(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="late_allowed"
              name="late_allowed"
              label="Mark late arrival after"
              required
              type="number"
              placeholder="Enter minutes"
              value={lateAllowed}
              onChange={(e) => setLateAllowed(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="half_leave"
              name="half_leave"
              label="Mark half leave after"
              placeholder="Enter minutes"
              required
              type="number"
              value={halfLeaveAfter}
              onChange={(e) => setHalfLeaveAfter(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="full_leave"
              name="full_leave"
              label="Mark full leave after"
              placeholder="Enter minutes"
              required
              type="number"
              value={fullLeaveAfter}
              onChange={(e) => setFullLeaveAfter(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <br />

            <h6 className={classes.heading}>Working Days</h6>
            <TextField
              id="start_date"
              name="start_date"
              label="Start Date (inclusive)"
              type="date"
              value={dateStart}
              onChange={(e) => setDateStart(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="end_date"
              name="end_date"
              label="End Date (inclusive)"
              type="date"
              disabled={!dateStart}
              value={dateEnd}
              onChange={(e) => setDateEnd(e.target.value)}
              className={isMobile() ? classes.TextField : classes.halfTextField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="flex-end"
            >
              <Grid item>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                >
                  Create
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      )}
    </>
  );
};

export default Time;
